import { render, staticRenderFns } from "./FileNaming.vue?vue&type=template&id=1ccd46e6&scoped=true&"
import script from "./FileNaming.vue?vue&type=script&lang=js&"
export * from "./FileNaming.vue?vue&type=script&lang=js&"
import style0 from "./FileNaming.vue?vue&type=style&index=0&id=1ccd46e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd46e6",
  null
  
)

export default component.exports